import { getBaseName } from "../dmpconnect/utils/redirect";

export const routes = {
  logout: { path: `${getBaseName(false)}/logout` },
  home: { path: getBaseName() },
  dmpSearch: { path: `${getBaseName(false)}/home/:page?/:extra?` },
  dp: { path: `${getBaseName(false)}/dp/:encodedNdp` },
  dpFromIns: { path: `${getBaseName(false)}/dmp/:encodedIns/dp` },
  configuration: { path: `${getBaseName(false)}/configuration/:tab?` },
  debug: { path: `${getBaseName(false)}/debug` },
  dmpConfig: { path: `${getBaseName(false)}/dmp-config` },
  esConfig: { path: `${getBaseName(false)}/es-config` },
  tseConfig: { path: `${getBaseName(false)}/tse-config` },
  cpxConfig: { path: `${getBaseName(false)}/cpx-config` },
  meds: { path: `${getBaseName(false)}/dmp/:encodedIns/meds/:hrSection?/:atcCode?/:cipCode?` },
  hr: { path: `${getBaseName(false)}/dmp/:encodedIns/hr/:hrSection?/:atcCode?/:cipCode?` },
  vidalConfig: { path: `${getBaseName(false)}/vidal-config` },
  dmpDocument: { path: `${getBaseName(false)}/dmp/:encodedIns/document/:encodedUniqueUUid` },
  dmpDocuments: { path: `${getBaseName(false)}/dmp/:encodedIns/documents` },
  imagery: { path: `${getBaseName(false)}/dmp/:encodedIns/imagery` },
  dmpMobileLanding: { path: `${getBaseName(false)}/dmp/:encodedIns/menu` },
  dmpDocumentsCategory: { path: `${getBaseName(false)}/dmp/:encodedIns/documents/:typeCode` },
  dmpInformation: { path: `${getBaseName(false)}/dmp/:encodedIns/information` },
  dmpAdministration: { path: `${getBaseName(false)}/dmp/:encodedIns/administration/:tab?` },
  webAccessPDFViewer: { path: `${getBaseName(false)}/dmp/view_web_access/:action` },
  listview: { path: `${getBaseName(false)}/dmp/:encodedIns/parcours-soin/:yearIndex?/:monthIndex?/:dayIndex?` },
  searchDocs: { path: `${getBaseName(false)}/dmp/:encodedIns/search-docs` },
  aldVitale: { path: `${getBaseName(false)}/ald/:subSection` },
  aldDmp: { path: `${getBaseName(false)}/dmp/:encodedIns/ald` },
  aatVitale: { path: `${getBaseName(false)}/aat/:subSection` },
  aatDmp: { path: `${getBaseName(false)}/dmp/:encodedIns/aat` },
  aatLanding: { path: `${getBaseName(false)}/aat` },
  mss: { path: `${getBaseName(false)}/mss/:mssFolderId?/:mssMessageId?` },
  mssConfig: { path: `${getBaseName(false)}/mss-config` },
  sentDocuments: { path: `${getBaseName(false)}/sentdocuments` },
  logs: { path: `${getBaseName(false)}/logs` },
  upload: { path: `${getBaseName(false)}/upload/:encodedIns` },
  pscInfo: { path: `${getBaseName(false)}/info` },
  openIdAuthCallback: { path: `${getBaseName(false)}/authcallback` },
  consents: { path: `${getBaseName(false)}/consents` },
  insiQualif: { path: `${getBaseName(false)}/insi-qualifications` },
};

export const exceptionRoutes = [
  routes.debug.path,
  routes.dmpConfig.path,
  routes.esConfig.path,
  routes.tseConfig.path,
  routes.openIdAuthCallback.path,
  `${getBaseName(false)}/silent-sso`,
  `${getBaseName(false)}/login-token`,
  `${getBaseName(false)}/bootstrap`,
  `${getBaseName(false)}/nav`,
  routes.logout.path,
  routes.vidalConfig.path,
  routes.logs.path,
  routes.pscInfo.path,
  routes.cpxConfig.path,
  routes.mssConfig.path,
];

export const doesNotTriggerInitApp = [
  routes.logout.path,
  routes.tseConfig.path,
  // routes.openIdAuthCallback.path,
];
